module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-03@2x.ada70af5.jpg";